import { Grid,Image,  Group, createStyles, Paper, Alert,Container, Button } from '@mantine/core';
import ntbslogo from "./images/logo.png";
import { InfoCircle, Refresh, User } from 'tabler-icons-react';
import { useSelector, useDispatch } from 'react-redux'


import { useEffect, useState} from 'react';

import GuestLobby from './GuestLobby';
import GuestInMeeting from './GuestInMeeting';
import GuestLeftMeeting from './GuestLeftMeeting';
import intl from 'react-intl-universal';
import { clear_setclientlanguage } from '../app/slice/mainslice';




const useStyles = createStyles((theme) => ({
  headerbg: {
    backgroundColor: "#ffffff",	
  },
  contback: {	
    vheight: `100vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "80vh",
    minWidth: "50vw",
    position: "relative",
  },
  sysback: {	
    vheight: `100vh`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minWidth: "70vw",
    position: "relative",
  },

  guestfooter: {
    position: 'relative',
    bottom: 0,
    left: 0,
    right: 0,
    height: 150,
    backgroundColor: "#efefef",
    borderTop: `1px solid #ddd`,
    marginTop: `20px`,
    paddingLeft: `20px`,
    paddingRight: `20px`,
  },
  footerheadline: {
    fontWeight: 200,
    fontSize: "1.2em",
    color: "#00445E"
  },
  inside: {
    listStyleType: "none",
    paddingLeft: 0,
    margin: "0 0 20px;"
  },
  inside_li: {
    fontWeight: 400,
    fontSize: "89%",
    color: "#00445E",
  },
  paper: { 
    minWidth: 600,
  },
  padtop10: {
    paddingTop: `40px`,
  },
}));


const GuestMain = () => {
    const dispatch = useDispatch()
    const { classes } = useStyles();
    const guestme = useSelector((state: any) => state.user.guest_meinfo)
    const notaronline = useSelector((state: any) => state.user.hostforguestisonline)
    const guest_joinlink = useSelector((state: any) => state.user.guest_joinlink)
    const guest_leftmeeting = useSelector((state: any) => state.user.guest_leftmeeting)
    const guest_notarleftmeeting = useSelector((state: any) => state.user.guest_notarleftmeeting)
    const guest_accsses_denied = useSelector((state: any) => state.user.guest_accsses_denied)
    const changelanguage = useSelector((state: any) => state.user.changelanguage)

    const [rejoin_onlang, setRejoin_onlang] = useState(false);   
   
    const icon = <InfoCircle />;
   
 
   /* useEffect(() => {
      const reqmeetingdatapayload = {
        MeetingParticipantId: guestme.id,
      };
      
        dispatch({ type: 'GUEST_SIGNALR_GETMEETINGDATA', payload: reqmeetingdatapayload });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);*/

    useEffect(() => {
        //console.log(notaronline)
        // Request Joinlink when Noart come to CMS Meeting
        if (notaronline && !guest_notarleftmeeting && !changelanguage) {
            //console.log("notaronline-requestjoinlink ----")
            requestjoinlink();
        }

        if (notaronline && guest_notarleftmeeting) {
         // console.log("guest_notarleftmeeting-requestjoinlink ----")
          requestjoinlink();
        }

        if (changelanguage) {
         // console.log("changelanguage-requestjoinlink ----", changelanguage)
          setRejoin_onlang(true);
        }

        const signalrActions = [
          { type: 'GUEST_SIGNALR_UPDATE_USERDATA', eventName: "OnChangeParticipantStatus_" + guestme.userId },
          { type: 'GUEST_SIGNALR_CHANGEMEETING_STATUSUSER', eventName: "OnChangeParticipantStatus_" + guestme.userId },
        ];
  
        signalrActions.forEach(action => {
          dispatch({ type: action.type, eventName: action.eventName });
        });

        /*console.log("---------------------")
        console.log("notaronline", notaronline)
        console.log("joinLink", guest_joinlink.joinLink)
        console.log("guest_notarleftmeeting", guest_notarleftmeeting)
        console.log("guest_accsses_denied", guest_accsses_denied)
        console.log("guest_leftmeeting", guest_leftmeeting)
        console.log("rejoin_onlang", rejoin_onlang)
        console.log("---------------------")*/
 


    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notaronline,guest_notarleftmeeting,changelanguage]);


    //console.log("---------------------")
    //console.log("guest_leftmeeting", guest_leftmeeting)
    //console.log("changelanguage", changelanguage)
    //console.log("rejoin_onlang", rejoin_onlang)
    //console.log("---------------------")

   

    const requestjoinlink = () => {
        const requestjoinlinkdata ={
            MeetingParticipantId: guestme.id,
        }

      dispatch({ type: 'GUEST_SIGNALR_REQUEST_JOINLINK', payload: requestjoinlinkdata});
      //console.log("requestjoinlink")
      setRejoin_onlang(false);
      dispatch(clear_setclientlanguage())
    }

    const buttonmessage = intl.get('VIDEO_BUTTON_REJOIN_CHANGELANG')
//console.log("guestmeetingparticipantsdata", guestmeetingparticipantsdata.length)

    
      
  if (guest_accsses_denied) {
    return (  
      <>  
       <Grid className={classes.headerbg}>
          <Grid.Col md={2} lg={2}>
              <Image
                  height={75}
                  width={220}
                  src={ntbslogo}
                          />
          </Grid.Col> 
          <Grid.Col md={9} lg={9} className={classes.padtop10}>
              <Group position="right">
                  <User />
                  {guestme.emailAddress} 
              </Group>
          </Grid.Col> 
      </Grid> 

        <Container fluid className={classes.contback}> 
              <Paper shadow="sm" p="xl" className={classes.paper}>
              <Group position="center" >
              <Image
                height={75}
                width={220}
                src={ntbslogo}
                    />
              </Group>
              <Group position="center" >
                  <Alert variant="filled" color="red" title="Zugriff verweigert!" icon={icon}>
                  Sie sind von diesem Meeting ausgeschlossen!
                </Alert>
              </Group>
            </Paper>
            </Container>

          <Grid className={classes.guestfooter}>
          <Grid.Col md={4} lg={4}>
          <span className={classes.footerheadline}>Informationen</span>
            <ul className={classes.inside}>
              <li className={classes.inside_li}>Impressum</li>
              <li className={classes.inside_li}>Datenschutzerklärung</li>
            </ul>
            </Grid.Col>
            <Grid.Col md={4} lg={4}>
          <span className={classes.footerheadline}>Links</span>
            <ul className={classes.inside}>
              <li className={classes.inside_li}>Support</li>
              <li className={classes.inside_li}>NTBS SOLUTIONS GmbH</li>
            </ul>
            </Grid.Col>
            <Grid.Col md={4} lg={4}>
            
          </Grid.Col>
          </Grid> 
          </>

    )
  }




    

  return (
    <>
        <Grid className={classes.headerbg}>
          <Grid.Col md={2} lg={2}>
              <Image
                  height={75}
                  width={220}
                  src={ntbslogo}
                          />
          </Grid.Col> 
          <Grid.Col md={9} lg={9} className={classes.padtop10}>
              <Group position="right">
                  <User />
                  {guestme.emailAddress} 
              </Group>
          </Grid.Col> 
      </Grid> 
  
        {(!notaronline && guest_joinlink.joinLink == null) && !guest_notarleftmeeting &&
         <GuestLobby requestjoinlink={requestjoinlink}/>
         }
        {(notaronline && guest_joinlink.joinLink !== undefined) && !guest_notarleftmeeting && !changelanguage &&
          <GuestInMeeting />
        }
        {guest_leftmeeting  && !rejoin_onlang &&
          <GuestLeftMeeting />
        }
        
        {rejoin_onlang &&
         <>
        <Container fluid className={classes.contback}> 
            <Paper shadow="sm" p="xl" className={classes.paper}>
         <Group position="center" >
            <Button 
                leftIcon={<Refresh size="2rem" />} 
                variant="filled" 
                color="green" 
                size="lg" 
                radius="md" 
                loaderPosition="right" 
                onClick={() => requestjoinlink ()}> {buttonmessage} 
            </Button>
         </Group>
         </Paper>
         </Container>
         </>
        }

      <Grid className={classes.guestfooter}>
          <Grid.Col md={4} lg={4}>
          <span className={classes.footerheadline}>Informationen</span>
            <ul className={classes.inside}>
              <li className={classes.inside_li}>Impressum</li>
              <li className={classes.inside_li}>Datenschutzerklärung</li>
            </ul>
            </Grid.Col>
            <Grid.Col md={4} lg={4}>
          <span className={classes.footerheadline}>Links</span>
            <ul className={classes.inside}>
              <li className={classes.inside_li}>Support</li>
              <li className={classes.inside_li}>NTBS SOLUTIONS GmbH</li>
            </ul>
            </Grid.Col>
            <Grid.Col md={4} lg={4}>
            
          </Grid.Col>
        </Grid> 
    </> 
    );
  }
  
  export default GuestMain;